/* PRELOAD */

var path = './dist/images/',
arrayOfImages = [];
arrayOfImages[0] = path+'arrow_.png';
arrayOfImages[1] = path+'start/bg-uvod.jpg';
arrayOfImages[2] = path+'start/uvodni.png';
//arrayOfImages[3] = path+'start/start-menu-3.png';
//arrayOfImages[4] = path+'start/start-menu-4.png';
//arrayOfImages[4] = path+'help.png';
/*arrayOfImages[3] = path+'_bg0.png';*/


/* add the rest of images */

$(function(){
	var completePreload = false;

	$.preload(arrayOfImages, 1, function(last){
		for (var i = 0; i < this.length; i++) {
			$('<img src="' + this[i] + '" alt="">').appendTo('#images');
		}
		if (last) {
			preloader = setInterval(
				function() {
					//if (Object.size(data2) == 8) {
						completePreload = true;
					//}
					if (completePreload === true) {
							stopAnimation();
							clearInterval(preloader);
							$('#loaderImage').hide();
							$('#startPage').show();
						}
				}, 1000
			);
		}
	});
});
